import { render } from "./PageNumber3.vue?vue&type=template&id=beded5e0&scoped=true"
import script from "./PageNumber3.vue?vue&type=script&lang=js"
export * from "./PageNumber3.vue?vue&type=script&lang=js"

import "./PageNumber3.vue?vue&type=style&index=0&id=beded5e0&scoped=true&lang=css"

import exportComponent from "/home/alex/Documents/EVO/investorpresentation/code/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-beded5e0"]])

export default __exports__